import React from "react";
import { useTheme } from "@mui/material/styles";
import styled from "@emotion/styled";
import { withTheme } from "@emotion/react";
import Chart from "react-apexcharts";

import { CardContent as MuiCardContent, Card as MuiCard, CircularProgress } from "@mui/material";

import useHome from "../../../hooks/user/useHome";
import { CardStyle } from "../common/styled";
import {
  LAYERD_SIGNATURE_WAF_LABEL,
  LAYERD_AI_SMART_PARSE_LABEL,
} from "../_new/detection/wafSourceLabels";

const Card = styled(MuiCard)`
  position: relative;
  box-shadow: none;
  border-radius: 3px;
  ${CardStyle};
`;
const CardContent = styled(MuiCardContent)`
  position: relative;
  &:last-child {
    padding-bottom: ${(props) => props.theme.spacing(4)};
  }
`;
const ChartWrapper = styled.div`
  height: 350px;
  width: 100%;
`;
const Root = styled.div`
  justify-content: center;
  align-items: center;
  display: flex;
  min-height: 100%;
`;
const WAFDetectChart = ({ setCustomRangeConfirm, setTimeRange, setCustomDateRange }) => {
  const theme = useTheme();

  const { sigs, smartparses } = useHome();
  const [data, setData] = React.useState([
    {
      name: LAYERD_SIGNATURE_WAF_LABEL,
      data: [],
    },
    {
      name: LAYERD_AI_SMART_PARSE_LABEL,
      data: [],
    },
  ]);
  const [options, setOptions] = React.useState({
    dataLabels: {
      enabled: false,
    },
    stroke: {
      curve: "smooth",
      width: 2,
    },
    xaxis: {
      type: "datetime",
      categories: [],
    },
    tooltip: {
      x: {
        format: "dd/MM/yy HH:mm",
      },
    },
    chart: {
      ...theme.typography.textSmall,
      fontColor: theme.palette.grey.darker,
    },
    colors: [theme.palette.custom.blue.main, theme.palette.green.opacity_85],
  });

  React.useEffect(() => {
    var categories = [];
    var sigDatas = [];
    var smartParseDatas = [];
    if (sigs?.length > 0) {
      sigs.forEach((sig) => {
        categories.push(sig.key_as_string);
      });
    }
    if (smartparses?.length > 0) {
      smartparses.forEach((sp) => {
        categories.push(sp.key_as_string);
      });
    }
    categories = Array.from(new Set(categories));
    categories.sort();
    if (categories.length > 0) {
      categories.forEach((cate) => {
        if (null === sigs || 0 === sigs.length) {
          sigDatas.push(0);
        } else {
          let sig = sigs.find((x) => x.key_as_string === cate);
          if (undefined === sig) {
            sigDatas.push(0);
          } else {
            sigDatas.push(sig.doc_count);
          }
        }

        if (null === smartparses || 0 === smartparses.length) {
          smartParseDatas.push(0);
        } else {
          let sp = smartparses.find((x) => x.key_as_string === cate);
          if (undefined === sp) {
            smartParseDatas.push(0);
          } else {
            smartParseDatas.push(sp.doc_count);
          }
        }
      });
    }
    setData([
      {
        name: LAYERD_SIGNATURE_WAF_LABEL,
        data: sigDatas,
      },
      {
        name: LAYERD_AI_SMART_PARSE_LABEL,
        data: smartParseDatas,
      },
    ]);
    setOptions({
      dataLabels: {
        enabled: false,
      },
      stroke: {
        curve: "smooth",
        width: 2,
      },
      xaxis: {
        type: "datetime",
        categories: categories,
      },
      tooltip: {
        x: {
          format: "dd/MM/yy HH:mm",
        },
      },
      chart: {
        ...theme.typography.textSmall,
        fontColor: theme.palette.grey.darker,
      },
      colors: [theme.palette.custom.blue.main, theme.palette.green.opacity_85],
    });
  }, [sigs, smartparses, theme.typography.textSmall, theme.palette.custom.blue.main, theme.palette.green.opacity_85, theme.palette.grey.darker]);

  return (
    <Card>
      <CardContent>
        <ChartWrapper>
          {sigs === null || smartparses === null ? (
            <Root>
              <CircularProgress />
            </Root>
          ) : (
            <Chart options={options} series={data} type="line" height="350" />
          )}
        </ChartWrapper>
      </CardContent>
    </Card>
  );
};

export default withTheme(WAFDetectChart);
